<div class="row">
  <div class="col-6">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard [hideTabs]="true">
          <sb-wizard-tab titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}"
                         icon="basicSettings" [active]="true">
            <form [formGroup]="form" class="wizard__forms p-5">
              <h3 *ngIf="playerSoftwareId" class="my-4">{{'lang.devices.editDeviceSoftware' |
                translate}}</h3>
              <h3 *ngIf="!playerSoftwareId" class="my-4">{{'lang.devices.createDeviceSoftware' |
                translate}}</h3>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Name">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Name" class="form-control" formControlName="Name"
                           sbAutofocus>
                    <div *ngIf="Name.touched && Name.errors?.required" class="alert alert-danger">
                      {{'lang.globals.nameWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <div class="form-group validateMe">
                      <label class="form-label" for="Version">{{'lang.devices.editDeviceSoftware.version' | translate}}<span
                        class="red">*</span></label>
                      <input type="text" id="Version" class="form-control"
                             formControlName="Version">
                      <div *ngIf="Version.touched && Version.errors?.required"
                           class="alert alert-danger">
                        {{'lang.globals.editDeviceSoftware.versionWarning' | translate}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="OS">{{'lang.devices.editDeviceSoftware.os' | translate}}<span
                      class="red">*</span></label>
                    <input type="text" id="OS" class="form-control" formControlName="OS">
                    <div *ngIf="OS.touched && OS.errors?.required" class="alert alert-danger">
                      {{'lang.devices.editDeviceSoftware.osWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Protocol">{{'lang.devices.editDeviceSoftware.protocol' | translate}}<span
                      class="red">*</span></label>
                    <input type="text" id="Protocol" class="form-control"
                           formControlName="Protocol">
                    <div *ngIf="Protocol.touched && Protocol.errors?.required"
                         class="alert alert-danger">
                      {{'lang.devices.editDeviceSoftware.protocolWarning' | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Description">{{'lang.globals.description' | translate}}</label>
                    <input type="text" id="Description" class="form-control"
                           formControlName="Description">
                  </div>
                </div>
              </div>
              <div class="wizard__footerActions">
                <button (click)="util.returnToNavigation(util.RoutingID.playerSoftware)" type="button"
                           class="btn btn-default btn-lg btn-wide">{{'lang.globals.cancel' | translate}}
                </button>
                <button (click)="updatePlayerSoftware()" type="button"
                           [disabled]="!form.valid || loading" class="btn btn-success btn-wide btn-lg">
                  {{!playerSoftwareId ? ('lang.globals.submit' | translate) : ('lang.globals.save' | translate)}}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
